import axios from "axios";

export const addMsg = async (token, data, id) => {
   
    const response = await axios.put(`${process.env.API_URL}/suppliers/${id}`,
        data,
        {
          withCredentials: true,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': '*/*',
            'content-type': 'application/json'
    
          }
        });
      return response;
  };

  export const getMsg = async (token, id) => {
   
     const response = await axios.get(`${process.env.API_URL}/suppliers/${id}`,       
         {
           withCredentials: true,
           headers: {
             'Authorization': `Bearer ${token}`,
             'Accept': '*/*',
             'content-type': 'application/json'
     
           }
         });
       return response;
   };